import { style } from '@app/shared/lib/Style';
import styled from '@emotion/styled';

export default styled.span({
    color: style.colors.primary
});
